import React, { memo } from 'react'

import * as S from './styles'

/**
 * @typedef {'primary' | 'default' | 'disabled' | 'warning' | 'success' | 'alert' | 'info'} IconColor
 */

/**
 * @typedef {Object} IconeProps
 * @property {string} nome
 * @property {IconColor} [color]
 * @property {string} [width]
 * @property {string} [height]
 * @property {string} [cursor]
 * @property {string} [transform]
 * @property {number} [opacity] - Opacidade em porcentagem (0-100)
 */

/**
 * @param {IconeProps} props
 */

const Icone = ({ nome, ...props }) => {
  if (!nome) return null

  const icon = require(`../../icones/_novoPadrao/${nome}.svg`)
  return <S.Icon nome={icon} {...props} />
}

export default memo(Icone)
